module.exports = __webpack_public_path__ + "static/media/Ga.ad140073.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/Ga.mp3
// module id = 75
// module chunks = 0